import React from "react";
import FisdapReports from "./fisdap-reports";

export default function ClinDocsSubmissions() {
  return <FisdapReports studentOnly />;
}
